import CloseIcon from "@mui/icons-material/Close";
import { Fab, SvgIcon, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useTranslation } from "react-i18next";
import { setActiveCesiumTool } from "~/redux/reducers/mapReducer";
import { useAppDispatch, useAppSelector } from "~/redux/store/store";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.contrastText,
  },
}));

const MeasurementButton = (): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation("cesium");
  const dispatch = useAppDispatch();
  const activeTool = useAppSelector((s) => s.map.activeCesiumTool);
  return activeTool === "measurement" ? (
    <Tooltip title={t("general:cancel").toString()}>
      <Fab
        size="small"
        color="primary"
        onClick={() => {
          dispatch(setActiveCesiumTool(undefined));
        }}
      >
        <CloseIcon className={classes.icon} />
      </Fab>
    </Tooltip>
  ) : (
    <Tooltip title={t("measure-triangle").toString()}>
      <Fab
        size="small"
        color="primary"
        onClick={() => {
          dispatch(setActiveCesiumTool("measurement"));
        }}
      >
        <SvgIcon className={classes.icon}>
          <path
            fill="currentColor"
            d="M3,5V21H9V19.5H7V18H9V16.5H5V15H9V13.5H7V12H9V10.5H5V9H9V5H10.5V9H12V7H13.5V9H15V5H16.5V9H18V7H19.5V9H21V3H5A2,2 0 0,0 3,5M6,7A1,1 0 0,1 5,6A1,1 0 0,1 6,5A1,1 0 0,1 7,6A1,1 0 0,1 6,7Z"
            id="path942"
          />
          <path
            d="M 9.1231818,20.404618 9.497861,20.029939 21.123185,8.4046195 v 0"
            id="path1063"
            style={{
              stroke: "currentColor",
              strokeWidth: 1.75748,
              strokeMiterlimit: 4,
              strokeDasharray: "1.75748, 1.75748",
              strokeDashoffset: 0,
              strokeOpacity: 1,
            }}
          />
        </SvgIcon>
      </Fab>
    </Tooltip>
  );
};

export default MeasurementButton;
